import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axiosInstance from "../../helpers/axiosInstance"

const initialState = {
    loading : false,
    status : false,
    userData: null,
    email: null,
    error : null,
};

export const login = createAsyncThunk("login", async(data) => {
    try{
        const response = await axiosInstance.post("/user/login", data);
        return response?.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || 'Server Not Responding');
    }
});

export const register = createAsyncThunk("register", async(data) => {
    try{
        const response = await axiosInstance.post("/user/register", data);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Something went wrong');
    }
});

export const changePassword = createAsyncThunk("changePassword", async(data) => {
    try{
        const response = await axiosInstance.post("/user/change_password", data);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Something went wrong');
    }
});

export const resetPassword = createAsyncThunk("resetPassword", async(data) => {
    try{
        const response = await axiosInstance.post("/user/reset_password", data);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Something went wrong');
    }
});

export const getPublicKey = createAsyncThunk("getPublicKey", async() => {
    try {
        const response = await axiosInstance.get("/user/get_public_key");
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Failed to fetch public key');
    }
});

export const forgotPassword = createAsyncThunk(
    "forgotPassword",
    async (data) => {
        try {
            const response = await axiosInstance.post(
                "/user/forgot_password",
                data
            );

            return response.data;
        } catch (error) {
            throw new Error(
                error?.response?.data?.message ||
                'Something went wrong'
            );
        }
    }
);

export const resetPasswordWithToken = createAsyncThunk(
    "resetPasswordWithToken",
    async (data) => {
        try {
            const response = await axiosInstance.post(
                "/user/reset_password_with_token",
                data
            );

            return response.data;
        } catch (error) {
            throw new Error(
                error?.response?.data?.message ||
                'Something went wrong'
            );
        }
    }
);

export const ssoLogin = createAsyncThunk("ssoLogin", async (data) => {
    try {
        const response = await axiosInstance.get("/auth/saml/login");
        return response.data; 
    } catch (error) {
        throw new Error(error.response?.data?.message || 'SSO login failed');
    }
});

const authSlice = createSlice({
    name : "auth",
    initialState,
    reducers: {
        clearState: (state) => {
            state.loading = false;
            state.status = false;
            state.userData = null;
            state.email = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(login.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(login.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
            state.userData = action.payload;
            state.email = action.payload.email;
        });
        builder.addCase(login.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(register.pending, (state) => {
            state.loading = true;
        }
        );
        builder.addCase(register.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
            state.userData = action.payload;
        });

        builder.addCase(register.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(changePassword.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(changePassword.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
            state.userData = action.payload;
        });
        builder.addCase(changePassword.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(resetPassword.pending, (state) => {
            state.loading = true;
        }
        );
        builder.addCase(resetPassword.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
            state.userData = action.payload;
        });
        builder.addCase(resetPassword.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(ssoLogin.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(ssoLogin.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
        });
        builder.addCase(ssoLogin.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(forgotPassword.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(forgotPassword.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
            state.userData = action.payload;
        });

        builder.addCase(forgotPassword.rejected, (state) => {
            state.loading = false;
        });


        builder.addCase(resetPasswordWithToken.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(
            resetPasswordWithToken.fulfilled,
            (state, action) => {
                state.loading = false;
                state.status = true;
                state.userData = action.payload;
            }
        );

        builder.addCase(
            resetPasswordWithToken.rejected,
            (state) => {
                state.loading = false;
            }
        );
        
    },
});

export const selectEmail = (state) => state.auth.email;

export default authSlice.reducer;